import Text from 'core-system/Text'
import React from 'react'
import Table, { TableRowCell, TableRow } from 'core-system/Table'
import StatusPill from 'features/Programs/Overview/Components/StatusPill'
import SecondaryButton from 'core-system/Button/SecondaryButton'

interface OnboardingTableRow {
  title: string
  owner: string
  status: string
  description: string
  dueDate: string
  actionButtonText: string
  onActionButtonClick: () => void
  actionButtonDisabled?: boolean
}

const ProgramRow = ({
  title,
  owner,
  status,
  description,
  dueDate,
  actionButtonText = 'Complete',
  onActionButtonClick,
  actionButtonDisabled,
}: OnboardingTableRow) => (
  <TableRow>
    <TableRowCell>
      <Text variant='body1'>{title}</Text>
    </TableRowCell>
    <TableRowCell>
      <Text variant='body1'>{owner}</Text>
    </TableRowCell>
    <TableRowCell>
      <StatusPill status={status} />
    </TableRowCell>
    <TableRowCell>
      <Text variant='body1'>{description}</Text>
    </TableRowCell>
    <TableRowCell>
      <Text variant='action4'>{dueDate}</Text>
    </TableRowCell>
    <TableRowCell>
      <SecondaryButton
        onClick={onActionButtonClick}
        disabled={actionButtonDisabled}
      >
        {actionButtonText}
      </SecondaryButton>
    </TableRowCell>
  </TableRow>
)

interface OnboardingTableProps {
  rows: OnboardingTableRow[]
}

const OnboardingTable = React.memo((props: OnboardingTableProps) => {
  const HeaderCell = (text: string) => (
    <TableRowCell>
      <Text fontWeight={600} variant={'action3'}>
        {text}
      </Text>
    </TableRowCell>
  )

  const headerCells = [
    HeaderCell('Title'),
    HeaderCell('Owner'),
    HeaderCell('Status'),
    HeaderCell('Description'),
    HeaderCell('Due Date'),
    HeaderCell('Action'),
  ]

  const rows = props.rows.map((row) => (
    <ProgramRow
      title={row.title}
      owner={row.owner}
      actionButtonText={row.actionButtonText}
      description={row.description}
      status={row.status}
      dueDate={row.dueDate}
      onActionButtonClick={row.onActionButtonClick}
      actionButtonDisabled={row.actionButtonDisabled}
    />
  ))

  return <Table maxRows={10} headerCells={headerCells} rows={rows} />
})

export default OnboardingTable
